import React, { type ReactNode } from "react";
import "./ContentHeading.css";
import { FormattedMessage } from "react-intl";

export interface IContentHeadingProps {
  returnLink?: ReactNode;
  children?: ReactNode;
}

export const ContentHeading = ({
  returnLink,
  children,
}: IContentHeadingProps) => (
  <div className="raange-content-heading">
    {returnLink && (
      <div className="raange-content-heading-return-link">
        <FormattedMessage id="content_heading.return_to" />
        {returnLink}
      </div>
    )}

    {children}
  </div>
);

/**
 * @deprecated
 */
export default ContentHeading;
